import React, { useState } from "react";
import { Form, Select, InputNumber } from "formik-antd";
import FormPrices from "./prices";

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

const Subform = (props) => {
    const { values, errors, setFieldValue } = props.formik;
    const services = props.allServices
        ? props.services
        : props.services.filter((item) => (values.services || []).indexOf(item?.id) !== -1);
    return (
        <>
            <Form.Item label="Currency" name="currency" hasFeedback={true} showValidateSuccess={true} required>
                <Select
                    placeholder="Currency"
                    name="currency"
                    showSearch
                    options={props.currencies}
                    filterOption={_filter}
                />
            </Form.Item>

            <Form.Item
                label="Rush fee percent"
                name="rush_percent"
                hasFeedback={true}
                showValidateSuccess={true}
                required
            >
                <InputNumber
                    name="rush_percent"
                    defaultValue={100}
                    min={0}
                    max={100}
                    formatter={(value) => `${value}%`}
                    parser={(value) => value.replace("%", "")}
                />
            </Form.Item>

            <Form.Item name="prices" hidden={true}></Form.Item>

            <FormPrices {...props} values={values} errors={errors} setFieldValue={setFieldValue} services={services} />
        </>
    );
};
export default Subform;
